import { createContext, useContext } from "react";

interface EntLinkContextValue {
  onEntClick: (entId: string) => void;
}

export const EntLinkContext = createContext<EntLinkContextValue | null>(null);

export const useEntLinkContext = () => useContext(EntLinkContext);
